module.exports = __webpack_public_path__ + "static/media/plus_filled.6538b527.svg";